import React from 'react';

import { Button } from '@gogame/components';

import MSIcon from './MSIcon';

export const MSLogin = (props) => {
  return (
    <Button {...props} variant={'outlined'} fullWidth={true} icon={<MSIcon />}>
      Sign in with Microsoft
    </Button>
  );
};
